import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Select2Multiple from "v-select2-multiple-component";
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from "advanced-laravel-vue-paginate";
import "advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import store from '../../store';
import {
  required
} from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "ParentList",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    AdvancedLaravelVuePaginate,
    Loading
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      searchData: {
        name: '',
        parent_no: '',
        campus_id: '',
        phone: '',
      },
      parentData: {},
      campusArr: [],
      isLoading: false,
      templatelLink: '',
      parentFile: '',
      parentFileName: '',
      disabled: false,
      invalidFile: false,
      submitted: false,
      isSearched: false,
      searchedData: null,
      isFilterOpen: false,
    };
  },

  validations: {
    parentFile: {
      required
    }
  },

  methods: {
    campusNameAction() {
      axios.get('campus/campusName')
        .then(res => {
          this.campusArr = res.data;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getParentList(page = 1) {
      axios.get("/parent/list?page=" + page)
        .then((response) => {
          this.parentData = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    chooseFile() {
      this.$refs.fileUploader.value = '';
      document.getElementById('parent-upload').click();
    },

    clearFile() {
      this.parentFile = '';
      this.parentFileName = '';
      document.getElementById('parent-upload').value = '';
      this.submitted = false;
      this.disabled = false;
      this.invalidFile = false;
    },

    onParentFileChange() {
      this.invalidFile = false;
      let selectedFile = document.getElementById('parent-upload').files;
      if (selectedFile.length) {
        let file = selectedFile[0];
        if (file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.parentFileName = file.name;
          this.parentFile = file;
        } else {
          this.invalidFile = true;
        }
      }
      this.disabled = false;
    },

    getTemplateLink() {
      var request = {
        params: {
          campus_id: store.state.user.campus_id
        }
      }
      axios.get("parent/getParentTemplateLink", request, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(res => {
        this.templatelLink = res.data;
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    importFile() {
      this.submitted = true;
      this.disabled = true;
      if (this.$v.$invalid) {
        this.disabled = false;
        return;
      } else {
        this.isLoading = true;
        let data = new FormData();
        data.append('parent_xlsx', this.parentFile);
        axios.post("parent/importParent", data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
          if (response.data.success == true) {
            this.$notification.success(response.data.message, {
              timer: 3,
              position: "bottomCenter"
            });
            this.disabled = false;
            this.getParentList();
            this.clearFile();
          } else {
            this.isLoading = false;
            this.disabled = false;
            this.clearFile();
            alert(response.data.message);
          }
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
      }
    },

    reset() {
      this.searchData.parent_no = '';
      this.searchData.name = '';
      this.searchData.campus_id = '';
      this.searchData.phone = '';
      this.isLoading = true;
      this.getParentList();
      this.isSearched = false;
    },

    search() {
      this.isLoading = true;
      this.searchParent();
    },

    searchParent(page = 1) {
      const params = {
        parent_no: this.searchData.parent_no,
        name: this.searchData.name,
        campus_id: this.searchData.campus_id,
        phone: this.searchData.phone
      };
      this.searchedData = params;
      this.isSearched = true;
      axios.get("parent/search?page=" + page, { params })
        .then((response) => {
          this.parentData = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    confirmDelete(id) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deleteParent(id);
      }
    },

    deleteParent(id) {
      axios.delete("/parent/delete/" + id)
        .then(response => {
          if (response.data.success == true) {
            this.isLoading = true;
            this.getParentList();
            this.$notification.success('Parent Deleted Successfully', {
              timer: 3,
              position: "bottomCenter"
            });
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          console.log("Parent Delete Error->", error);
        });
    },

    showCreate() {
      this.$router.push({
        path: "/parent/create",
      });
    },

    showEdit(id) {
      this.$router.push({
        name: "parentEdit",
        params: {
          id: id,
        },
      });
    },

    showDetail(id) {
      this.$router.push({
        name: "parentDetail",
        params: {
          id: id
        }
      });
    },

    changeEvent(val, fieldName) {
      this.$set(this, fieldName, val);
    },

    excelDownload(status) {
      console.log(this.isSearched, this.searchedData);
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData }
        : { campus_id: this.searchData.campus_id, };
      axios.get('/parent/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          fileLink.setAttribute('download', status + `_parent_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$router.push({
              name: "login"
            });
          }
          this.isLoading = false;
        });
    },

    formatLastActive(date) {
      const lastActive = moment(date);
      return lastActive.isSame(moment(), "day")
        ? `Today, ${lastActive.format("hh:mm A")}`
        : lastActive.format("YYYY-MM-DD hh:mm A");
    },

    getLastActiveClass(date) {
      const now = moment().startOf("day");
      const lastActive = moment(date).startOf("day");
      const baseClass = "status-dot";

      if (lastActive.isSame(now, "day")) {
        return `${baseClass} active-today`;
      } else if (now.diff(lastActive, "days") <= 7) {
        return `${baseClass} active-week`;
      } else {
        return `${baseClass} active-old`;
      }
    },
  },

  mounted() {
    this.isLoading = true;
    this.getParentList();
    this.getTemplateLink();
    this.campusNameAction();
  },
};
